module.exports = __webpack_public_path__ + "static/media/avatar.eba95a88.jpg";